import { render, staticRenderFns } from "./NewRubricForm.vue?vue&type=template&id=246b7b42&scoped=true"
import script from "./NewRubricForm.vue?vue&type=script&lang=js"
export * from "./NewRubricForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=246b7b42&prod&scoped=true&lang=css&external"
import style1 from "./NewRubricForm.vue?vue&type=style&index=1&id=246b7b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b7b42",
  null
  
)

export default component.exports